import { render, staticRenderFns } from "./Bubble1.vue?vue&type=template&id=4e06e19a"
import script from "./Bubble1.vue?vue&type=script&lang=js"
export * from "./Bubble1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports